export const companyTypes = [
  { label: 'Limited Liability Company (LLC)', value: 'LimitedLiabilityCompany' },
  { label: 'Professional Limited Liability Company', value: 'ProfessionalLimitedLiabilityCompany' },
  { label: 'Non-Profit Organisation', value: 'NonProfitCorporation' },
  { label: 'S-Corporation', value: 'sCorporation' },
  { label: 'C-Corporation', value: 'cCorporation' },
];
